import BaseModule from '$src/js/base/BaseModule';
import ShopModule from '$src/js/shop/ShopModule';

declare global {
  interface Window {
    app: Bootstrap;
  }
}

export default class Bootstrap {
  constructor() {
    BaseModule.getInstance().boot();
    ShopModule.getInstance().boot();
  }

  static getInstance(): Bootstrap {
    if (typeof window.app === 'undefined') {
      window.app = new Bootstrap();
    }

    return window.app;
  }
}
